/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityRef } from './entityRef';

export interface OrgContextOut {
  version: number;
  markdown: string;
  created_by: EntityRef | null;
  created_at: string | null;
}
